// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import UpdateCountController from "./update_count_controller"
application.register("update-count", UpdateCountController)

import AutoSaveStatusController from "./auto_save_status_controller"
application.register("auto-save-status", AutoSaveStatusController)

import AutoSaveProofTypeController from "./auto_save_proof_type_controller"
application.register("auto-save-proof-type", AutoSaveProofTypeController)

import PostNewTabController from "./post_new_tab_controller"
application.register("post-new-tab", PostNewTabController)

import DistrictFilterController from "./district_filter_controller"
application.register("district-filter", DistrictFilterController)

import StatusPillController from "./status_pill_controller"
application.register("status-pill", StatusPillController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import SeniorsPackagesController from "./seniors_packages_controller"
application.register("seniors-packages", SeniorsPackagesController)

import SeniorsGalleryController from "./seniors_gallery_controller"
application.register("seniors-gallery", SeniorsGalleryController)

import SeniorsFaqSearchController from "./seniors_faq_search_controller"
application.register("seniors-faq-search", SeniorsFaqSearchController)

import SeniorsStepController from "./seniors_step_controller"
application.register("seniors-step", SeniorsStepController)
